import { render, staticRenderFns } from "./add-certificate.vue?vue&type=template&id=d793f524&scoped=true&"
import script from "./add-certificate.vue?vue&type=script&lang=js&"
export * from "./add-certificate.vue?vue&type=script&lang=js&"
import style0 from "./add-certificate.vue?vue&type=style&index=0&id=d793f524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d793f524",
  null
  
)

export default component.exports